export const projectPDFsSelector = ({ uploads: { projectPDFs: value } }) => value;
